export interface Testimonial {
  quote: string;
  author: string;
  role: string;
  company: string;
}

// Ship empty — real approved quotes are a human-gated follow-up for Alejandro.
export const TESTIMONIALS: Testimonial[] = [];
